export default {"src":"/_next/static/media/error.6b53c92d.svg","height":20,"width":20};